var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSnsLinkdin = function SvgSnsLinkdin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.626 0H1.371C.737 0 .223.502.223 1.12v13.313c0 .62.514 1.123 1.148 1.123h13.255c.634 0 1.152-.503 1.152-1.123V1.121C15.778.502 15.26 0 14.626 0Zm-9.79 13.255H2.528V5.832h2.308v7.423ZM3.682 4.817a1.337 1.337 0 1 1 0-2.674 1.337 1.337 0 0 1 0 2.674Zm9.795 8.438h-2.304v-3.61c0-.86-.017-1.968-1.2-1.968-1.2 0-1.383.938-1.383 1.906v3.673H6.283V5.832h2.214v1.014h.031c.308-.583 1.061-1.199 2.184-1.199 2.334 0 2.765 1.537 2.765 3.537v4.072Z",
    fill: "current"
  })));
};
export default SvgSnsLinkdin;